import { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import mapPinIcon from "../assets/mapPin.svg";
import searchIcon from "../assets/searchIcon.svg";
import popularIcon from "../assets/popularIcon.svg";
import dropDownIcon from "../assets/dropdownIcon.svg";
import CardsList from "../components/CardsList";
import Pagination from "../components/Pagination";
import BrowseByCities from "../components/BrowseByCities";
import axios from "axios";
import CountryStore from "../store/CountryStore";
import CategoryStore from "../store/CategoryStore";
import CityStore from "../store/CityStore";
import { ClipLoader } from "react-spinners";
import { useLocation, useParams } from "react-router-dom";
import CityBreadCrumb from "../components/CityBreadCrumb";

function CityResultPage({}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(16);
  const [selectedCity, setSelectedCity] = useState("");
  const [cityData, setCityData] = useState([]);
  const [isCityDropdownVisible, setIsCityDropdownVisible] = useState(false);
  const [isPopularityDropdownVisible, setIsPopularityDropdownVisible] = useState(false);
  const [cardsData, setCardsData] = useState([]);
  const [popularity, setPopularity] = useState("asc");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const country = CountryStore((state) => state.country);
  const category = CategoryStore((state) => state.category);
  const setCity = CityStore((state) => state.setCity);
  const location = useLocation();
  const currentLocation = location.pathname;
  const tempCity = currentLocation.split('/')[2];
  const globalCity = tempCity.includes('-')
  ? tempCity.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
  : tempCity.charAt(0).toUpperCase() + tempCity.slice(1);

  // console.log(city);
  // console.log(country);
  // console.log(category);

  const cityDropdownRef = useRef(null);
  const filterDropdownRef = useRef(null);

  async function fetchVendors() {
    setLoading(true);
    try {
      if (country === "Country" || !category) {
        // console.log("Country and category are required");
        return;
      }

      const formData = new FormData();
      formData.append("cat_slug", category);
      formData.append("country_name", country);
      formData.append("popular", popularity);
      formData.append("city_name", globalCity);
      // console.log(country, category, globalCity, popularity);
      const response = await axios.post(
        "/api/get_category_vendor_list.php",
        formData
      );

      const responseStr = response.data;

      try {
        const citiesIndex = responseStr.indexOf('{"cities":');

        if (citiesIndex !== -1) {
          const vendorsStr = responseStr.substring(0, citiesIndex);
          const citiesStr = responseStr.substring(citiesIndex);

          const vendorsData = JSON.parse(vendorsStr);
          const citiesData = JSON.parse(citiesStr);

          setCardsData(vendorsData);
          setCityData(citiesData.cities);
          // console.log(citiesData)
        } else {
          console.error("Could not find cities data in response");
          setCardsData(JSON.parse(responseStr));
        }
      } catch (parseError) {
        console.error("Error parsing response:", parseError);
        console.error("Response string:", responseStr);
        setLoading(false);
      }
      setLoading(false);
      // console.log(response.data)
      // setCardsData(response.data);
      // if (response.data.cities && Array.isArray(response.data.cities)) {
      //   setCityData(response.data.cities);
      //   console.log(cityData)
      // }
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  }

  async function fetchCities() {
    setLoading(true);
    try {
      console.log("fetchCities called");
      if (country === "Country") {
        console.log("Country and category are required");
        return;
      }
      const formData = new FormData();
      formData.append("country_name", country);
      formData.append("popular", popularity);
      const response = await axios.post(
        "https://elsopro.com/api/get_category_vendor_list.php",
        formData
      );
      const responseStr = response.data;
      try {
        const citiesIndex = responseStr.indexOf('{"cities":');
        if (citiesIndex !== -1) {
          const citiesStr = responseStr.substring(citiesIndex);
          const citiesData = JSON.parse(citiesStr);
          setCityData(citiesData.cities);
          // console.log(citiesData)
        }
      } catch (parseError) {
        console.log("Error parsing response:", parseError);
        console.log("Response string:", responseStr);
        setLoading(false);
      }
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  }

  const hasMounted = useRef(false);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }
    fetchCities();
    // setSelectedCity('');
  }, [country]);

  useEffect(() => {
    fetchVendors();
  }, [popularity, globalCity]);

  useEffect(() => {
    if (cardsData.length <= 0) {
      setFilteredData([]);
    }
    if (cardsData.length > 0) {
      console.log(cardsData);
      const filteredArray = cardsData.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.company_name === item.company_name)
      );
      const filtered = filteredArray.filter((item) =>
        item.company_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [cardsData, searchTerm]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        cityDropdownRef.current &&
        !cityDropdownRef.current.contains(event.target)
      ) {
        setIsCityDropdownVisible(false);
      }
      if (
        filterDropdownRef.current &&
        !filterDropdownRef.current.contains(event.target)
      ) {
        setIsPopularityDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function handlePopularity(order) {
    order === "A - Z" ? setPopularity("asc") : setPopularity("desc");
    setIsPopularityDropdownVisible(false);
    // console.log(popularity);
  }

  // function handleCityClick(city){
  //   setSelectedCity(city);
  //   setCity(city);
  //   setIsCityDropdownVisible(false);
  //   navigate(`${city}`)
  //   window.scrollTo({
  //     top: 0,
  //     behavior: 'smooth',
  //   });
  // }
  const params = useParams();

  useEffect(() => {
    setCity(params.cityOrCategory[0].toUpperCase() + params.cityOrCategory.slice(1));
    console.log(params.cityOrCategory);
  }, [params.cityOrCategory]);

  function handleCityClick(city) {
    setSelectedCity(city);
    setCity(city);
    setIsCityDropdownVisible(false);
    const formattedCountry = country.replace(/\s+/g, "-").toLowerCase();
    const formattedCategory = category.replace(/\s+/g, "-").toLowerCase();
    const formattedCity = city.replace(/\s+/g, "-").toLowerCase();
    window.location.href = `/${formattedCountry}/${formattedCity}/${formattedCategory}`;
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentPosts = filteredData.slice(firstPostIndex, lastPostIndex);

  const toggleCityDropdown = () =>
    setIsCityDropdownVisible(!isCityDropdownVisible);
  const togglePopularityDropdown = () =>
    setIsPopularityDropdownVisible(!isPopularityDropdownVisible);

  return (
    <div className="font-inter flex flex-col min-h-screen">
      <Navbar setSelectedCity={setCity} />

      {/* Main Content */}
      <div className="container mx-auto px-4 sm:px-6 md:px-6 lg:px-8 xl:px-16 2xl:px-24 my-10 mt-5">
        {/* Search Controls */}
        <CityBreadCrumb/>
        <div className="flex flex-wrap text-[#4E5562] items-center justify-between gap-4">
          <div className="sm:text-base mx-auto lg:mx-0">
            Showing {filteredData.length} results
          </div>
          <div className="flex flex-wrap gap-4">
            {/* Keyword Search */}
            <div className="w-full sm:w-56 md:w-60 rounded-lg md:rounded-full flex border border-[#CAD0D9] md:rounded-3xl h-10 pl-3 pr-2 items-center">
              <div className="ml-2 sm:ml-0 lg:ml-2">
                <img src={searchIcon} alt="search" />
              </div>
              <input
                id="default-search"
                className="w-full sm:w-36 sm:text-sm ml-3 md:w-44 border-none focus:outline-none"
                placeholder="Search by keywords"
                required
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* City Filter with Dropdown */}
            <div
              ref={cityDropdownRef}
              className="relative w-32 sm:w-40 md:w-40 h-10 rounded-lg md:rounded-full flex items-center gap-2 border border-[#CAD0D9] md:rounded-3xl p-2"
            >
              <button
                onClick={toggleCityDropdown}
                className="w-full flex items-center justify-between bg-transparent py-2 px-2 rounded-md text-sm"
              >
                <div className="flex items-center gap-2">
                  <img src={mapPinIcon} alt="map icon" />
                  <span className="text-sm sm:text-sm">
                    {globalCity || "City"}
                  </span>
                </div>
                <img
                  src={dropDownIcon}
                  alt="dropdown icon"
                  className="w-3 h-3 2xl:w-4 2xl:h-4"
                />
              </button>
              {isCityDropdownVisible && (
                <div className="absolute z-10 left-0 right-0 top-8 mt-2 bg-white mx-2 border border-gray-300 rounded-md shadow-md max-h-40 overflow-y-auto">
                  <ul className="py-1">
                    {cityData &&
                      cityData.map((city, index) => (
                        <li
                          key={index}
                          className="px-3 py-1 text-sm hover:bg-gray-100 hover:text-black cursor-pointer"
                          onClick={() => handleCityClick(city.city_name)}
                        >
                          {city.city_name}
                        </li>
                      ))}
                  </ul>
                </div>
              )}
            </div>

            {/* Popularity Filter with Dropdown */}
            <div
              ref={filterDropdownRef}
              className="relative w-[190px] sm:w-44 h-10 flex rounded-lg md:rounded-full items-center gap-2 border border-[#CAD0D9] md:rounded-3xl sm:rounded-lg p-2"
            >
              <button
                onClick={togglePopularityDropdown}
                className="w-full flex items-center justify-between bg-transparent py-2 px-2 rounded-md text-sm"
              >
                <div className="flex items-center gap-2">
                  <img src={popularIcon} alt="popular icon" />
                  <span className="text-sm sm:text-sm">
                    {popularity === "asc" ? "A - Z" : "Z - A"}
                  </span>
                </div>
                <img
                  src={dropDownIcon}
                  alt="dropdown icon"
                  className="w-3 h-3 2xl:w-4 2xl:h-4"
                />
              </button>
              {isPopularityDropdownVisible && (
                <div className="absolute z-10 left-0 right-0 top-8 mt-2 bg-white mx-4 border border-gray-300 rounded-md shadow-md max-h-40 overflow-y-auto">
                  <ul className="py-1">
                    {["A - Z", "Z - A"].map((order, index) => (
                      <li
                        key={index}
                        className="px-3 py-1 text-sm hover:bg-gray-100 hover:text-black cursor-pointer"
                        onClick={() => handlePopularity(order)}
                      >
                        {order}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className={`flex items-center justify-center ${
            loading ? "h-[200px]" : ""
          }`}
        >
          {loading ? (
            <ClipLoader color="#006b4f" size={35} speedMultiplier={1} />
          ) : (
            <CardsList
              cardsData={currentPosts}
              remarks={"super"}
              searchTerm={""}
            />
          )}
        </div>

        {/* Pagination */}
        <Pagination
          totalPosts={filteredData.length}
          postsPerPage={postsPerPage}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />

        <BrowseByCities cityData={cityData} />
      </div>

      <Footer />
    </div>
  );
}

export default CityResultPage;